import ExhibitionMap from "./exhibition-map";

export default ExhibitionMap;